<template>
  <div id="lista-de-assinantes" class="column">
    <div class="container container_com-fundo container_com-margem">
      <loading :ativo="loading.visivel" />

      <h4 class="titulo titulo_pequeno" v-if="!loading.visivel && assinantes.length === 0">
        Nenhum assinante encontrado
      </h4>

      <table class="tabela tabela_listrada tabela_com-largura-total" v-if="assinantes.length > 0">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Cargo</th>
            <th>E-mail</th>
            <th>Assinatura Digital</th>
            <th>Atual</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="assinante of assinantes" :key="assinante.Id">
            <td>{{ assinante.Nome }}</td>
            <td>{{ assinante.Cargo }}</td>
            <td>{{ assinante.Email }}</td>
            <td>{{ assinante.PossuiAssinaturaDigital ? 'Sim' : 'Não' }}</td>
            <td>
              <input
                type="checkbox"
                class="formulario__checkbox-marcador"
                :checked="assinante.EhAtual"
                :disabled="assinante.EhAtual"
                @change="abrirModalDeConfirmacao(assinante)"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <modal v-if="modalVisivel" @close="fecharModal">
      <div>
        <h3 class="titulo titulo_medio">Confirmar assinante atual</h3>
        <p class="mensagem-confirmacao">
          <strong>{{ assinanteSelecionado && assinanteSelecionado.Nome }}</strong>
          passará a ser o assinante atual. Deseja prosseguir?
        </p>
        <div class="grade__coluna u-texto-alinhado-a-direita">
          <button type="button" @click="fecharModal" class="botao botao_cinza">Cancelar</button>
          <button type="button" @click="confirmarDefinicaoDeAtual" class="botao botao_cor-terciaria">Confirmar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/shared/Modal';
import Loading from '@/components/shared/Loading';

export default {
  name: 'lista-de-assinantes',
  components: { Modal, Loading },
  data() {
    return {
      assinantes: [],
      loading: { visivel: true },
      modalVisivel: false,
      assinanteSelecionado: null,
    };
  },
  created() {
    this.obterAssinantes();
  },
  methods: {
    obterAssinantes() {
      this.exibirCarregamento();

      this.$api.get('/Assinante')
        .then((response) => {
          this.assinantes = response.data;
          this.esconderCarregamento();
        })
        .catch((error) => {
          this.tratarErro(error);
          this.esconderCarregamento();
        });
    },
    abrirModalDeConfirmacao(assinante) {
      this.assinanteSelecionado = assinante;
      this.modalVisivel = true;
    },
    fecharModal() {
      this.modalVisivel = false;
      this.assinanteSelecionado = null;
    },
    confirmarDefinicaoDeAtual() {
      this.$api.put(`/Assinante/${this.assinanteSelecionado.Id}/DefinirComoAtual`)
        .then(() => {
          this.fecharModal();
          this.obterAssinantes();
        })
        .catch((error) => {
          this.tratarErro(error);
          this.fecharModal();
        });
    },
    exibirCarregamento() {
      this.loading.visivel = true;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// ListaDeAssinantes.vue?5c7fdd37